import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const ResourceNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#ResourceNotification1)" />
    <Path
      d="M16.273 9.348a.224.224 0 0 0-.229-.031l-3.641 1.576a1.434 1.434 0 0 1-.56.102 2.04 2.04 0 0 1-.783-.154.951.951 0 0 1-.177-.098.757.757 0 0 1 .055-.024l3.312-1.434.494.21V8.88a.292.292 0 0 0-.107-.231.223.223 0 0 0-.228-.031l-3.642 1.576a.844.844 0 0 0-.29.183.5.5 0 0 0-.149.352l.001.01V16.308h.001a.566.566 0 0 0 .2.405c.293.26.787.405 1.313.412.249 0 .501-.037.735-.137l3.643-1.578a.28.28 0 0 0 .159-.26V9.578a.294.294 0 0 0-.107-.231Zm-2.31-1.056a.292.292 0 0 0-.101-.21.224.224 0 0 0-.23-.03l-3.64 1.576a1.442 1.442 0 0 1-.561.101c-.284.001-.578-.065-.782-.155a.923.923 0 0 1-.177-.097.741.741 0 0 1 .054-.024l3.313-1.434.494.21v-.616a.293.293 0 0 0-.107-.23.224.224 0 0 0-.229-.032L8.355 8.93a.843.843 0 0 0-.29.182.5.5 0 0 0-.147.362v5.571a.566.566 0 0 0 .2.405c.294.26.787.405 1.313.412.143 0 .286-.016.425-.046v-5.077a.964.964 0 0 1 .287-.7 1.31 1.31 0 0 1 .45-.285l3.37-1.46Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="ResourceNotification1"
        x1={12}
        y1={-2}
        x2={12}
        y2={26.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#00BDBD" />
        <Stop offset="1" stopColor="#008FA3" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default ResourceNotification;
